import { UiOption } from '@/lib/helpers';

export type BreadCrumb = 'group' | 'context' | 'policy' | 'agent' | 'scoped-policy';

export const HELP_CENTER_URL = 'https://help.ai.f5.com/';

export const BreadCrumbMap: Record<BreadCrumb, UiOption> = {
  group: { label: 'Groups', value: '/config/groups' },
  context: { label: 'Data Sources', value: '/wais/datasources' },
  policy: { label: 'Group Policies', value: '/wais/group-policies' },
  'scoped-policy': { label: 'Scoped Policies', value: '/config/policy/scoped' },
  agent: { label: 'Assistants', value: '/wais/assistants' },
};
